var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_6405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0059 0C18.6288 0 24.0059 5.37703 24.0059 12C24.0059 18.623 18.6288 24 12.0059 24C5.38289 24 0.00585938 18.623 0.00585938 12C0.00585938 5.37703 5.38289 0 12.0059 0ZM8.25412 18.744V9.37266H5.13863V18.744H8.25412ZM19.4863 18.744V13.3699C19.4863 10.4914 17.9494 9.1523 15.9 9.1523C14.2474 9.1523 13.5071 10.0612 13.0927 10.6995V9.37266H9.97795C10.0192 10.2519 9.97795 18.744 9.97795 18.744H13.0926V13.5104C13.0926 13.2302 13.1128 12.9502 13.1953 12.75C13.4201 12.1905 13.933 11.611 14.7935 11.611C15.9201 11.611 16.3715 12.4707 16.3715 13.7299V18.744H19.4863ZM6.71742 4.85391C5.65148 4.85391 4.95506 5.55469 4.95506 6.4732C4.95506 7.37236 5.6303 8.09245 6.67617 8.09245H6.69628C7.78261 8.09245 8.45878 7.37236 8.45878 6.4732C8.43862 5.55469 7.78266 4.85391 6.71742 4.85391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_6405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9c252676862474ec6f564baf4ab602c7.svg";
export { ForwardRef as ReactComponent };